<div class="contact-container">
  <div class="contact-title" [innerHTML]="(isTablet ? 'contact_Data2' : 'contact_Data1') | i18n"></div>
  <div class="video">
    <video src="/assets/images/contact/vid.mov" autoplay muted></video>
  </div>
  <div class="form">
    <form [formGroup]="contactForm" (ngSubmit)="submitForm()">
      <div *ngIf="!contacted">
        <div class="form-title" [innerHTML]="'contact_Data3' | i18n"></div>
        <div class="form-group inputs" [ngClass]="{ 'invalid-check': formSubmitted && contactForm.get('name').invalid }">
          <input class="input" type="text" id="name" formControlName="name" required
            placeholder="{{ 'contact_Data4' | i18n: translationModes.PLACEHOLDER }}">
          <div class="required-invalid" *ngIf="formSubmitted && contactForm.get('name').invalid"
            [innerHTML]="'contact_Data13' | i18n"></div>
        </div>
        <div class="form-group inputs" [ngClass]="{ 'invalid-check': formSubmitted && contactForm.get('mail').invalid }">
          <input class="input" type="email" id="mail" formControlName="mail" required
            placeholder="{{ 'contact_Data5' | i18n: translationModes.PLACEHOLDER }}">
          <div class="required-invalid" *ngIf="formSubmitted && contactForm.get('mail').invalid"
            [innerHTML]="'contact_Data13' | i18n"></div>
        </div>
        <div class="form-group inputs">
          <input class="input" type="tel" id="phone" formControlName="phone"
            placeholder="{{ 'contact_Data6' | i18n: translationModes.PLACEHOLDER }}">
        </div>
        <div class="form-group inputs" [ngClass]="{'autocomplete': showAutocomplete}">
          <input class="input" type="country" id="country" formControlName="country"
            placeholder="{{ 'contact_Data7' | i18n: translationModes.PLACEHOLDER }}" (input)="autocompleteCountries($event)" [value]="contactForm.value.country">
            <ul class="autocomplete-list" *ngIf="showAutocomplete">
              <li *ngFor="let country of filteredCountries" (click)="selectCountry(country)">{{ country }}</li>
            </ul>
        </div>
        <div class="form-group inputs">
          <textarea class="input textarea" id="message" formControlName="message" required
            placeholder="{{ 'contact_Data8' | i18n: translationModes.PLACEHOLDER }}"></textarea>
        </div>
        <div class="form-group checkbox"
          [ngClass]="{ 'invalid-check': formSubmitted && contactForm.get('termsAndConditions').invalid }">
          <input type="checkbox" formControlName="termsAndConditions">
          <div class="tos">
            <div [innerHTML]="'contact_Data9' | i18n"></div>
            <a [href]="getRouterLink('TermsOfUse')" target="_blank" [innerHTML]="'contact_Data10' | i18n"></a>
          </div>
        </div>
        <div class="form-group checkbox last-checkbox">
          <input type="checkbox" formControlName="receiveCommunications">
          <div [innerHTML]="'contact_Data11' | i18n"></div>
        </div>
      </div>
      <div *ngIf="contacted" [innerHTML]="'contact_Data14' | i18n" class="contacted"></div>
      <div class="form-group">
        <button type="submit" [innerHTML]="'contact_Data12' | i18n"></button>
      </div>
    </form>
  </div>
</div>
